import request from "@/utils/request";

export function searchGoods(params) {
  return request({
    url: "/product/goods/h5/goods-es/page",
    method: "get",
    params,
  });
}
export function getActBrands(brandName) {
  return request({
    url: "/product/participate/h5/act-brand/list/" + brandName,
    method: "get",
  });
}
export function getSearchWords() {
  return request({
    url: "/product/goods/h5/history",
    method: "get",
  });
}
export function getActList(id) {
  return request({
    url: "/product/participate/brand-goods/" + id,
    method: "get",
  });
}
